<template>
  <div id="app">
    <RouterView />
  </div>
</template>

<script setup>
import { RouterView } from 'vue-router'
</script>

<style>
body {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Microsoft YaHei", Arial, sans-serif;
  background:
      radial-gradient(circle at 18% 0%, rgba(0, 240, 255, .28), transparent 28%),
      radial-gradient(circle at 90% 18%, rgba(124, 58, 237, .28), transparent 30%),
      radial-gradient(circle at 50% 100%, rgba(16, 185, 129, .18), transparent 36%),
      linear-gradient(180deg, #020617, #030712);
  color: #e5faff;
  padding: 12px;
}
* {
  box-sizing: border-box;
}
</style>